import { GLOBAL } from 'saddlebag-browser';

const container = 'debug-controls';

const debugControlsInit = async (): Promise<void> => {
  const $document = GLOBAL.getDocument();
  const $debugControls = $document.getElementById(container);
  if (!$debugControls) {
    return;
  }

  const { default: bootstrap } = await import('./render');
  bootstrap($debugControls);
};

export default debugControlsInit;
